export function PastSessionsTableError({
    message = 'Failed to load sessions',
}: {
    message?: string;
}) {
    return <div className="flex items-center justify-center h-32 text-destructive">{message}</div>;
}
